import { FileAPI } from 'api'

export async function upload(file) {
  const data = new FormData()
  data.append('file', file)
  return FileAPI
  .post('/upload', data, {
    raw: true,
    headers: {},
  })
  .then(response => response.data)
}